import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { Router, RouterModule } from '@angular/router';
import { AppSettings } from '@shared/models/settings/app-settings';
import { SignalsService } from '@shared/services/signals/signals.service';
import { CommonModule } from '@angular/common';

interface TabItem {
  id: number;
  label: string;
  route: string;
  command?(): void;
}

@Component({
    selector: 'app-tab-menu',
    imports: [
        CommonModule,
        TabsModule,
        RouterModule
    ],
    templateUrl: './tab-menu.component.html',
    styleUrl: './tab-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabMenuComponent implements OnInit {

  tabItems: TabItem[] = [];
  activeItem?: TabItem;
  appSettings?: AppSettings;
  activeIndex: number = 0;

  constructor(
    private signalService: SignalsService,
    private router: Router,
  ) { }


  ngOnInit(): void {
    this.tabItems = [
      {
        id: 0,
        label: 'Table View',
        route: '/flights/flight-table',
      },
      {
        id: 1,
        label: 'Calendar View',
        route: '/flights/flight-calendar',
      }
    ];


    const defaultItemIndex = this.signalService.defaultTabItem$();

    const locationUrl = location.pathname;
    this.activeItem = this.tabItems[defaultItemIndex];
    if (locationUrl.includes('flight-calendar')) {
      //this.activeItem = this.tabItems[1];
      this.activeIndex = 1;
      this.router.navigate([this.tabItems[1].route])
    }
    else if (defaultItemIndex === 1) {
      this.activeItem = this.tabItems[1];
      this.activeIndex = 1;
      this.router.navigate(['flights', 'flight-calendar'])
    }
    else if (defaultItemIndex === 0) {
      //this.activeItem = this.tabItems[0];
      this.activeIndex = 0;
      this.router.navigate(['flights', 'flight-table'])
    }
  }

  // onActiveTabChange(event: TabItem): void {
  //   this.activeItem = event;
  // }

  tabMenu = {
    root: {
      transition: 'background-color 1.0s ease',
    },
    tab: {
      borderWidth: '0 0 1px 0',
      borderColor: '{surface.400}',
      hoverBorderColor: '{surface.400}',
      activeBorderColor: '{surface.400}',
      color: '{surface.500}',
      hoverColor: '{surface.500}',
      activeColor: '{primary.600}',
      padding: '0.75rem',
    },
    activeBar: {
      height: '2px',
      bottom: '0px',
      background: '{primary.600}',
    },
    colorScheme: {
      colorScheme: {
        light: {
          tab: {
            background: '{surface.0}',
            hoverBackground: '{surface.0}',
            activeBackground: '{surface.0}',
          },
        },
        dark: {
          tab: {
            background: '{surface.0}',
            hoverBackground: '{surface.0}',
            activeBackground: '{surface.0}',
          },
        },
      }
    }
  }

}
